import React, { FC, useEffect, useState } from 'react';
import { useLocation, useMatch } from 'react-router-dom';

import Button from '../../Controls/Button';
import Search from '../../Controls/Search';

import { routes } from '../../../routing';
import { $l } from '../../../locales';

import css from './style.module.scss';

interface IProps {
  isMenuOpened: boolean;
  toggleMenu: () => void;
}

const MobileHeader: FC<IProps> = ({ isMenuOpened, toggleMenu }) => {
  const [isSearchOpened, toggleSearch] = useState(false);
  const [goBackSearchRoute, setGoBackSearchRoute] = useState(routes.$root);
  const location = useLocation();
  const isSearchRoute = useMatch(routes.search);
  const isIos = /iPhone|iPad|iPod/.test(window.navigator.userAgent);

  useEffect(() => {
    toggleSearch(false);
  }, [location]);

  useEffect(() => {
    if (!isIos) return;

    if (isSearchOpened) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [isSearchOpened, isIos]);

  const showSearch = () => {
    setGoBackSearchRoute(location.pathname);
    toggleSearch(true);

    if (isMenuOpened) {
      toggleMenu();
    }
  };

  return (
   <div className={css.header}>
     <div className={css.header__row}>
       <div className={css.header__burger}>
         <Button
           onClick={toggleMenu}
           id="menu"
           iconSize="24"
           icon={`24--${isMenuOpened ? "close-menu" : "burger-menu"}`}
           variant="icon"
           noHover
         />
       </div>
       <div className={css.header__title}>{$l('HEADER.MOBILE_TITLE')}</div>
       <div className={css.header__actions}>
         <Button
           id="search"
           iconSize="24"
           icon="24--search"
           variant="icon"
           noHover
           onClick={showSearch}
         />
       </div>
     </div>
     <div className={css.header__placeholder}></div>
     {(isSearchOpened || isSearchRoute) && (
       <Search
         isSearchOpened={isSearchOpened}
         goBackSearchRoute={goBackSearchRoute}
         toggleSearch={toggleSearch}
       />
     )}
   </div>
  )
}

export default MobileHeader;
